function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import * as OUTLINED_ICONS from './outline';
import * as SOLID_ICONS from './solid';
import * as COLORS from '../theme/colors';
export const Icon = ({
  type,
  label,
  outlined = false,
  decorative = false,
  size = 24,
  color,
  ...props
}) => {
  const IconComponent = (outlined ? OUTLINED_ICONS : SOLID_ICONS)[type];
  const accessibleProps = decorative ? {
    'aria-hidden': true
  } : {
    role: 'img',
    'aria-label': label || type
  };
  const fillType = outlined ? 'stroke' : 'fill';
  const fillProps = color ? {
    [fillType]: COLORS[color]
  } : {
    [fillType]: 'currentColor'
  };
  return /*#__PURE__*/React.createElement(IconComponent, _extends({
    title: label || type,
    height: size,
    width: size,
    focusable: "false"
  }, fillProps, accessibleProps, props));
};
export default Icon;
//# sourceMappingURL=index.js.map